"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var CustomerCompanyDetailPageActions;
(function (CustomerCompanyDetailPageActions) {
    CustomerCompanyDetailPageActions["RecordAdding"] = "RecordAdding";
    CustomerCompanyDetailPageActions["RecordAdded"] = "RecordAdded";
    CustomerCompanyDetailPageActions["RecordDeleting"] = "RecordDeleting";
    CustomerCompanyDetailPageActions["RecordDeleted"] = "RecordDeleted";
    CustomerCompanyDetailPageActions["RecordLoading"] = "RecordLoading";
    CustomerCompanyDetailPageActions["RecordLoaded"] = "RecordLoaded";
    CustomerCompanyDetailPageActions["RecordEditing"] = "RecordEditing";
    CustomerCompanyDetailPageActions["RecordEdited"] = "RecordEdited";
    CustomerCompanyDetailPageActions["RecordLoadFailure"] = "RecordLoadFailure";
    CustomerCompanyDetailPageActions["Cancel"] = "Cancel";
    CustomerCompanyDetailPageActions["RecordDeactivated"] = "RecordDeactivated";
    CustomerCompanyDetailPageActions["RecordActivated"] = "RecordActivated";
    CustomerCompanyDetailPageActions["SubmissionError"] = "SubmissionError";
})(CustomerCompanyDetailPageActions || (CustomerCompanyDetailPageActions = {}));
exports.default = CustomerCompanyDetailPageActions;
